module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-back002.87a0c348.jpg";